import { render } from "./PackageDocumentParticipants.vue?vue&type=template&id=1c31196e"
import script from "./PackageDocumentParticipants.vue?vue&type=script&lang=js"
export * from "./PackageDocumentParticipants.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__